import { render, staticRenderFns } from "./ClientFormModal.vue?vue&type=template&id=20f1d2c2&scoped=true&"
import script from "./ClientFormModal.vue?vue&type=script&lang=js&"
export * from "./ClientFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1d2c2",
  null
  
)

export default component.exports